import * as React from 'react';
import { ControlFacet } from '../models/controls/ControlFacet';
import { IWithWizardInjectedProps } from '../components/decorators/withWizard';
import { defaultRenderComponentOption } from '../components/controls/defaultRenderComponentControlOption';
import { IComponentAsProps } from '@uifabric/utilities/lib/IComponentAs';

/**
 * @public
 */
export type IDeleteWizardProps = IWithWizardInjectedProps & {
  onDelete: () => Promise<void>;
  itemKeys: string[];
  /**
   * Whether or not the delete wizard should 'default' to confirm deletion for the user, if presented.
   */
  defaultToDelete?: boolean;
};

/**
 * @public
 */
export interface IDeleteActionControlProps {
  itemKey: string;
  /**
   * Whether or not the given item is one of many items to be deleted.
   */
  isBatchDelete: boolean;
}

/**
 * @public
 */
export interface IDeleteActionControlOverrides {
  /**
   * Override for whether or not the user may delete a given item.
   */
  isAvailable: boolean;
  /**
   * Override for the 'wizard' which prompts a user for deletion.
   * To override behaviors, wrap this
   */
  deleteWizard: React.ComponentType<IComponentAsProps<IDeleteWizardProps>>;
}

/**
 * Control handler to override item deletion behavior.
 * @public
 */
export const deleteActionControl: ControlFacet<IDeleteActionControlProps, IDeleteActionControlOverrides> =
  new ControlFacet<IDeleteActionControlProps, IDeleteActionControlOverrides>('deleteActionControl', {
    deleteWizard: defaultRenderComponentOption<IDeleteWizardProps>()
  });

// TODO Delete this misspelled name.
/**
 * @deprecated This is misspelled. Use deleteActionControl instead.
 */
export const deleteActionControler = deleteActionControl;
